import { memo } from "react";

const ExplandableHeaderDetail = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => {
  return (
    <div className="text-ib-pt-main flex-1 min-w-[calc(50%-8px)] md:min-w-[calc(25%-8px)] md:max-w-[calc(25%-8px)]">
      <div className="w-full text-ib-pt-color-gray-1000 truncate">{label}</div>
      <p className="w-full text-ib-pt-color-neutral-800 font-ib-bold truncate">
        {value}
      </p>
    </div>
  );
};

export default memo(ExplandableHeaderDetail);
